import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Spinner from "../../../common/Spinner";
import { closeCustomModal } from "../../../custom/modals";

class MiscChargeReportList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sortExpression: ""
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit = () => {
        const { filters, handleClose } = this.props;
        const { sortExpression } = this.state;
        const requestData = {
            ...filters,
            sortExpression
        };

        if (filters.merchandiserId) {
            requestData.merchandiserId = filters.merchandiserId.value;
        }

        if (filters.jobId) {
            requestData.jobId = filters.jobId.value;
        }

        this.props.handleSubmit(requestData, handleClose);
    };

    render() {
        const { scheduleReportLoading } = this.props;
         return (
                <div>
                    {scheduleReportLoading ? <Spinner /> : null}
                    <div className="clearfix text-right mt-2">
                        <button
                            className="btn btn-outline-primary ml-2"
                            onClick={this.props.handleClose}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-success ml-2"
                            onClick={this.handleSubmit}
                        >
                            Export
                        </button>
                    </div>
                </div>
        );
    }
}

MiscChargeReportList.propTypes = {
    handleClose: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    isChargeApproval: PropTypes.bool
};

const mapStateToProps = state => ({
    scheduleReportLoading: state.draft.scheduleReportLoading,
});

const mapStateToDispatch = dispatch => ({
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(MiscChargeReportList);
